module.exports = __webpack_public_path__ + "assets/images/pages/creando/awwwards.png?8280bd95";